if (!global._babelPolyfill) {
    require("@babel/polyfill");
}

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as actions from "../../../../actions/actions";

import EduBilling from "./nounproject-edu-billing";
import EduPricing from "../../../nounproject-edu-pricing";

class EduBillingContainer extends React.Component {
    constructor(props) {
        super(props);

        this.props.getCurrentUser();
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="columns six">
                        <EduPricing />
                    </div>

                    <div className="columns six">
                        <EduBilling user={this.props.user} />
                    </div>
                </div>
            </div>
        );
    }
}

EduBillingContainer.propTypes = {
    user: PropTypes.object
};

EduBillingContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let { user } = state;

    return {
        user
    };
}

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser
})(EduBillingContainer);
